import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@org/shared-services';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Only call getCurrentUser() if currentUserValue is null
  if (authService.currentUserValue !== null) {
    return checkRolesAndReturn(authService.currentUserValue, route, router, state);
  }

  // Otherwise, fetch current user from backend
  return authService.getCurrentUser().pipe(
    take(1),
    switchMap(user => {
      if (user) {
        return checkRolesAndReturn(user, route, router, state);
      } else {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
      }
    })
  );
};

// Helper function for role checks
function checkRolesAndReturn(user: any, route: ActivatedRouteSnapshot, router: Router, state: RouterStateSnapshot) {
  const roles = route.data['roles'] as Array<string>;
  if (roles) {
    const hasRole = user.roles && user.roles.some((role: string) => roles.includes(role));
    if (!hasRole) {
      return of(router.createUrlTree(['/unauthorized']));
    }
  }
  return of(true);
}
